module.exports = __webpack_public_path__ + "img/分区01.de0561b5.png";